<script setup lang="ts">
import i18n from 'src/i18n'
import { ref } from 'vue'
import VxButton from '../base/VxButton/VxButton.vue'
import BaseDialog from '../base/BaseDialog.vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  message: {
    type: String,
    required: true
  },
  okButtonLabel: {
    type: String,
    required: false,
    default: i18n.t('aceptar')
  },
  cancelButtonLabel: {
    type: String,
    required: false,
    default: i18n.t('cancelar')
  },
  warning: {
    type: Boolean,
    default: false
  },
  isSaveDialog: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits<{
  close: []
  accept: []
}>()

const isVisible = ref(false)

function confirm() {
  emit('accept')
  close()
}

function open() {
  isVisible.value = true
}

function close() {
  isVisible.value = false
  emit('close')
}

defineExpose({
  open,
  close
})
</script>

<template>
  <BaseDialog
    class="confirm-dialog"
    v-model:visible="isVisible"
    modal
    :title="props.title"
  >
    <p class="confirm-message">{{ props.message }}</p>
    <template #footer>
      <div class="buttons">
        <VxButton
          class="close-button"
          :outlined="true"
          :label="props.cancelButtonLabel"
          :icon="'mi mi-close'"
          @click="close()"
        />
        <VxButton
          :warning="warning"
          :icon="isSaveDialog ? 'pi pi-check' : 'mi mi-trash'"
          :label="props.okButtonLabel"
          @click="confirm()"
        />
      </div>
    </template>
  </BaseDialog>
</template>

<style lang="scss">
.p-dialog .p-dialog-footer {
  justify-content: center;
}
</style>

<style lang="scss" scoped>
.confirm-dialog {
  min-width: 20rem;
  min-height: 13rem;

  .confirm-message {
    max-width: 25rem;
    text-align: center;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;

    :deep(.p-button-icon) {
      font-size: 1rem;
    }

    .close-button {
      :deep(.p-button-icon) {
        font-size: 1.25rem;
      }
    }
  }
}
</style>
